import '../../utils/context-menu/CreateContextMenus.js'
import 'leaflet-simple-map-screenshoter'
import {map as mapEndpoints } from '../../../../api/api-endpoints.js'
import year from '../../../../utils/year.js'


export const threadsDateSliderMixin = {
  props: {
    years: {
      default: () => ([])
    }
  },
  data() {
    return {
      year: this.$route.params.year || year.getCurrentYear()
    }
  },
  computed: {
    yearList() {
      let data = []
      if (this.years.length) {
        data = this.years
      } else if (this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())) {
        data = this.$store.getters.readUrlEndpoint(this.getYearListEndpoint()).year
      }
      let list = []
      data.sort(function(a, b){
        return a.year-b.year
      }).forEach(i=>{
        list.push(i.year || i)
      })
      return list
    },
    min() {
      return this.yearList[0]
    },
    max() {
      return this.yearList.slice(-1)[0]
    },
  },
  methods: {
    getYearListEndpoint() {
      return mapEndpoints.yearFuture()
    },
    yearHandler (newVal) {
      if(newVal > 2000) {
        this.replaceRoute({year: newVal}, false)
      }
    },
  },
  mounted() {
    let promises = []
    promises.push(this.$store.dispatch('updateUrlEndpoint', {
      endpoint: this.getYearListEndpoint()
    }))
    return Promise.all(promises)
  }
}
